import { types } from '../actions/types';

const initialState = {
    data: {},
};

const setFontFamilyReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case types.SET_FONT_FAMILY:
            return {
                ...state,
                data: payload,
            };
        default:
            return state;
    }
};

export default setFontFamilyReducer